export const DETAILS =
    [
        {
            id: 0,
            name: 'Areca Palm',
            name1: 'Areca Palm',
            image1: '/care/areca/img1.jpg',
            image2: '/care/areca/img2.jpg',
            image3: '/care/areca/img3.jpg',
            category: 'mains',
            price: '$10',
            featured: true,
            description: 'Areca palm plants help in absorbing indoor air pollutants like acetone, xylene,and toluene which emits from petroleum products and paints and wooden furniture,absorb harmful pollutants from indoor air and provide fresh air thus helps in minimizing upper respiratory tract diseases causes mainly because of toluene',
            in_cart: false,
            description1: 'Areca palm plants help in absorbing indoor air pollutants like acetone'
        },
        {
            id: 1,
            name: 'Money Plant',
            name1: 'Money Plant',
            image1: '/care/money/img1.jpg',
            image2: '/care/money/img2.jpg',
            image3: '/care/money/img3.jpg',
            price: '$10',
            featured: false,
            description: 'It energizes the home by filtering air and increasing oxygen inflow.Feng Shui experts recommend keeping one plant near each computer, television, or WiFi router.Placing a money plant in front of a sharp corner or angle reduces anxiety and stress.It also helps avoid arguments and sleep disorders.',
            in_cart: false,
            description1: 'It energizes the home by filtering air and increasing oxygen inflow.'
        },
        {
            id: 2,
            name: 'English Ivy',
            name1: 'English Ivy',
            image1: '/care/english/img1.jpg',
            image2: '/care/english/img2.jpg',
            image3: '/care/english/img3.jpg',
            price: '$10',
            featured: false,
            description: 'English Ivy is extremely popular in outdoor landscaping. English ivies are one of the top 10 air-purifying plants,according to the National Aeronautics and Space Administration (NASA). English ivies can remove toxins like: •	benzene •	formaldehyde  •	xylene  • toulene These toxins can cause sick building syndrome. Sick building syndrome is when people feel ill when spending time in a particular building or room.One study also found that English ivies could reduce particles of fecal matter and mold. Researchers found that the amount of fecal matter dropped by more than 94 percent in 12 hours. Mold went down by 78.',
            in_cart: false,
            description1: 'English Ivy is extremely popular in outdoor landscaping.'
        },
        {
            id: 3,
            name: 'Spider Plant',
            name1: 'Spider Plant',
            image1: '/care/spider/img1.jpg',
            image2: '/care/spider/img2.jpg',
            image3: '/care/spider/img3.jpg',
            price: '$10',
            featured: false,
            description: 'One of the easiest indoor plants to maintain,the Spider Plant produces oxygen whilst purifying the air in your home and office by absorbing carbon monoxide, formaldehyde and xylene. Additionally, Spider Plants are non-toxic and are in fact edible, making them safe for pets and young children. When placed in office and home spaces Spider Plants can assist in <b>fostering happy vibes</b>, increasing productivity, decreasing stress and enriching overall well-being.',
            in_cart: false,
            description1: 'One of the easiest indoor plants to maintain',
        },
        {
            id: 4,
            name: 'Peace Lily',
            name1: 'Peace Lily',
            image1: '/care/peace/img1.jpg',
            image2: '/care/peace/img2.jpg',
            image3: '/care/peace/img3.jpg',
            price: '$10',
            featured: false,
            description: 'Peace Lily is one such plant–It can absorb benzene, formaldehyde, toluene, xylene and carbon monoxide effectively, which was even proved in the famous NASA experiment. It can be as equally effective as Golden Pothos in absorbing VOCs, proven in this Japanese study.',
            in_cart: false,
            description1: 'Peace Lily is one such plant–It can absorb benzene'
        },
        {
            id: 5,
            name: 'Snake Plant',
            name1: 'Snake Plant',
            image1: '/care/snake/img1.jpg',
            image2: '/care/snake/img2.jpg',
            image3: '/care/snake/img3.jpg',
            price: '$10',
            featured: false,
            description: 'Snake plants are known for their ability to help remove toxic air pollutants.Though in small contributions, snake plants can absorb cancer-causing pollutants, including CO2, benzene, formaldehyde, xylene, and toluene.With the ability to absorb and remove harmful toxins, snake plants can act as an effective defense against airborne allergies.',
            in_cart: false,
            description1: 'Snake plants are known for their ability to help remove toxic air pollutants.'
        },
        {
            id: 6,
            name: 'Dwarf Date Palm (Phoenix Roebelenii)',
            name1: 'Dwarf Date Palm',
            image1: '/care/dwarf/img1.jpg',
            image2: '/care/dwarf/img2.jpg',
            image3: '/care/dwarf/img3.jpg',
            price: '$10',
            featured: false,
            description: 'Dwarf or Pygmy palms are the babies of the palm family. They are relatively easy to grow in partial shade, growing up to six to 10 feet with their fronds reaching six foot too!. Toxins removed: formaldehyde and xylene.',
            in_cart: false,
            description1: 'Dwarf or Pygmy palms are the babies of the palm family.'
        },
        {
            id: 7,
            name: 'Philodendron',
            name1: 'Philodendron',
            image1: '/care/philo/img1.jpg',
            image2: '/care/philo/img2.jpg',
            image3: '/care/philo/img3.jpg',
            price: '$10',
            featured: false,
            description: 'The heart-shaped philodendron is a luscious addition to indoor spaces. Philo’s are relatively easy to look after they just need moderate water and bright, indirect sunlight.',
            in_cart: false,
            description1: 'The heart-shaped philodendron is a luscious addition to indoor spaces.'
        },
        {
            id: 8,
            name: 'Chrysanthemums (Chrysanthemum morifolium)',
            name1: 'Chrysanthemums',
            image1: '/care/cyran/img1.jpg',
            image2: '/care/cyran/img2.jpg',
            image3: '/care/cyran/img3.jpg',
            image4: '/care/cyran/pic4.jpg',
            price: '$10',
            featured: false,
            description: 'Chrysanthemums, otherwise known as disbuds or mums are not only a great addition to a floral arrangement but they look great in your home and are known as one of the best air purifiers around. They are among the more difficult air purifiers to grow but the payoff is beautiful colourful blooms. They enjoy good air flow, bright indirect sunlight and watering with warm water only, making sure that they are allowed to dry fully in between drinks.',
            in_cart: false,
            description1: 'Chrysanthemums, otherwise known as disbuds or mums'
        },
        {
            id: 9,
            name: 'Boston Fern (Nephrolepis exaltata v. Bostoniesis)',
            name1: 'Boston Fern',
            image1: '/care/bos/img1.jpg',
            image2: '/care/bos/img2.jpg',
            image3: '/care/bos/img3.jpg',
            image4: '/care/bos/pic4.jpg',
            price: '$10',
            featured: false,
            description: 'This easy-to-grow fern is known for its sword-shaped fronds which makes it perfect for a hanging basket or pedestal. The Boston Fern thrives in humid environments and requires consistent moisture. Keep them happy with regular misting, moist soil and position them in indirect sunlight near windows, balconies and patios. In winter cut the fronds back by around 2-inches to help regenerate and grow in the warmer months.',
            in_cart: false,
            description1: 'This easy-to-grow fern is known for its sword-shaped fronds'
        }
    ]